export const redirectUri = process.env.REACT_APP_REDIRECT_URI;
// Se publicó en internet la aplicación
// Esto llevó a que se expusieran los servicos (cambiando el nombre)
// Cambiando el nombre de los host
const isExternal = window.location.origin !== redirectUri;

export const azureClientId = process.env.REACT_APP_AZURE_CLIENT_ID;
export const azureClientSecret = process.env.REACT_APP_AZURE_CLIENT_SECRET;
export const authUrl = process.env.REACT_APP_AUTH_URL;
export const tokenUrl = process.env.REACT_APP_TOKEN_URL;
export const userInfo = process.env.REACT_APP_USER_INFO;
export const apiUrl = isExternal
  ? process.env.REACT_APP_API_URL_EXTERNAL
  : process.env.REACT_APP_API_URL;
export const apiYClickMaster = isExternal
  ? process.env.REACT_APP_API_COMBOS_EXTERNAL
  : process.env.REACT_APP_API_COMBOS;
export const apiCertificationsAdminContracts = isExternal
  ? process.env.REACT_APP_API_CERTIFICATIONS_EXTERNAL
  : process.env.REACT_APP_API_CERTIFICATIONS;
export const apiMasterCertifications = isExternal
  ? process.env.REACT_APP_API_CERTIFICATIONS_BACK_EXTERNAL
  : process.env.REACT_APP_API_CERTIFICATIONS_BACK;
export const homeWebYClick = isExternal
  ? process.env.REACT_APP_HOME_WEB_YCLICK_EXTERNAL
  : process.env.REACT_APP_HOME_WEB_YCLICK;
export const apiCertificationsApp = isExternal
  ? process.env.REACT_APP_API_CERTIFICATIONS_URL_EXTERNAL
  : process.env.REACT_APP_API_CERTIFICATIONS_URL;
export const apiAdministrationApp = isExternal
  ? process.env.REACT_APP_API_ADMINISTRATION_EXTERNAL
  : process.env.REACT_APP_API_ADMINISTRATION;
export const credentialsKey = process.env.REACT_APP_CREDENTIALS_KEY;
